import { memo } from 'react';
import { Divider, Flex } from '@banhala/ui-kit';
import { MumulLiveProfile } from './MumulLiveProfile';
import { useMumulLiveProfile } from './hooks/useMumulLiveProfile';

/**
 * EXP1789 섹션 (간판 영역).
 * 대조군(A)은 노출 모수 집계용 여백만, 실험군(B)은 여백 + 프로필을 렌더한다.
 * 미노출(비실험/DEFAULT/리허설 등)이면 렌더하지 않는다.
 */
export const MumulLiveProfileSection = memo(() => {
  const {
    isVisible,
    isExposed,
    status,
    marketName,
    marketImageUrl,
    onPress,
    trackingRef,
    expTargetRef,
  } = useMumulLiveProfile();

  if (!isVisible || status == null) {
    return null;
  }

  // expTargetRef/trackingRef: 실제 뷰포트 진입을 감지해 로깅을 게이팅 (useMumulLiveProfile 참고)
  return (
    <Flex>
      {/* EXP1789 노출 모수 집계 기준. 집계 전용이라 아무것도 그리지 않고 뷰포트 판정용 높이만 준다. */}
      <Flex ref={expTargetRef} height={1} />
      {isExposed && (
        <Flex ref={trackingRef}>
          <MumulLiveProfile
            status={status}
            marketName={marketName}
            marketImageUrl={marketImageUrl}
            onPress={onPress}
          />
          <Divider size={'medium'} />
        </Flex>
      )}
    </Flex>
  );
});
